module.exports = __webpack_public_path__ + "static/atom-a720c0a66fcf7827c92a619f2d0c51b8.svg";